<template>
    <section>
        <b-row>
            <b-col :md="6">
                <b-overlay
                    :show="!reload"
                >
                    <StatisticsCard
                        :isFilter="!!filter.usageDate"
                        :data="summary"
                        :theme="theme"
                    />
                </b-overlay>
            </b-col>
            <b-col :md="6">
                <b-overlay
                    :show="!reload"
                >
                    <AccountBarCard
                        :themeColors="themeColors"
                        :selectedProject="selectedProject"
                        :data="usageAccountId"
                        @filter:project="filterProject"
                    />
                </b-overlay>
            </b-col>
        </b-row>
        <b-row>
            <b-col :md="6" :cols="6">
                <b-overlay
                    :show="!reload"
                >
                    <MonthlyDailyLineCard
                        :theme="theme"
                        :themeColors="themeColors"
                        :fullData="fullMonths"
                        :filterData="{ monthlyCost, dailyCost }"
                        :startDate="Number(summary.start && summary.start.substring(8, 10))"
                        @filter:indexes="filterIndexes"
                    />
                </b-overlay>
            </b-col>
            <b-col>
                <b-overlay
                    :show="!reload"
                >
                    <FullDailyLineCard
                        :theme="theme"
                        :themeColors="themeColors"
                        :fullData="fullMonths"
                        :filterData="{ monthlyCost, dailyCost }"
                        @filter:items="filterItems"
                    />
                </b-overlay>
            </b-col>
        </b-row>
        <b-row>
            <b-col :md="6">
                <b-overlay
                    :show="!reload"
                >
                    <ProductPieCard
                        field="productCode"
                        :themeColors="themeColors"
                        :fullData="fullProductCode"
                        :filterData="productCode"
                        @filter:items="filterItems"
                    >
                        <template #title>
                            {{ $t('org.billing.Product') }}
                        </template>
                    </ProductPieCard>
                </b-overlay>

            </b-col>
            <b-col :md="6">
                <b-overlay
                    :show="!reload"
                >
                    <ProductPieCard
                        field="productCategory"
                        :themeColors="themeColors"
                        :fullData="fullProductCategory"
                        :filterData="productCategory"
                        @filter:items="filterItems"
                    >
                        <template #title>
                            {{ $t('org.billing.Category') }}
                        </template>
                    </ProductPieCard>
                </b-overlay>
            </b-col>
        </b-row>
        <b-row>
            <b-col :md="7">
                <b-overlay
                    :show="!reload"
                >
                    <RegionMapCard
                        field="region"
                        :fullData="fullRegion"
                        :filterData="region"
                        @filter:items="filterItems"
                    ></RegionMapCard>
                </b-overlay>
            </b-col>
            <b-col :md="5">
                <b-overlay
                    :show="!reload"
                >
                    <ResourceCard
                        field="resourceId"
                        :data="resourceId"
                        :count="summary.resourceIdCount"
                        @filter:items="filterItems"
                    />
                </b-overlay>
                <b-overlay
                    :show="!reload"
                >
                    <TagCard
                        field="tag"
                        :data="{ tag, availableTags }"
                        :count="summary.tagCount"
                        @filter:items="filterItems"
                    />
                </b-overlay>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-overlay
                    :show="!reload"
                >
                    <DetailTableCard
                        :data="detail"
                        :itemDescription="itemDescription"
                        @filter:description="filterDescription"
                    />
                </b-overlay>
            </b-col>
        </b-row>
    </section>
</template>

<script>
import { inject, computed, getCurrentInstance, ref, watch, onUnmounted } from '@vue/composition-api'
import StatisticsCard from './_components/StatisticsCard'
import AccountBarCard from './_components/AccountBarCard'
import MonthlyDailyLineCard from './_components/MonthlyDailyLineCard'
import FullDailyLineCard from './_components/FullDailyLineCard'
import ProductPieCard from './_components/ProductPieCard'
import RegionMapCard from './_components/RegionMapCard'
import ResourceCard from './_components/ResourceCard'
import TagCard from './_components/TagCard'
import DetailTableCard from './_components/DetailTableCard'

import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
export default {
    components: {
        StatisticsCard,
        AccountBarCard,
        MonthlyDailyLineCard,
        FullDailyLineCard,
        ProductPieCard,
        RegionMapCard,
        ResourceCard,
        TagCard,
        DetailTableCard
    },
    setup (props, context) {
        const {
            changeProject,
            qtypeParam
        } = useSelectProjectAndGroup()
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const themeColors = inject('themeColors')
        const theme = inject('theme')

        const filter = ref({})
        const scrollTop = ref(0)
        const top = ref(-100)
        const right = ref(-20)
        const fullMonths = ref([])
        const fullProductCode = ref([])
        const fullProductCategory = ref([])
        const fullRegion = ref([])
        const reload = ref(true)

        const selectedProject = computed(() => store.getters.selectedProject)
        const summary = computed(() => store.getters['$_dynamicSearch/summary'])
        const indexes = ref([])
        const monthlyCost = computed(() => store.getters['$_dynamicSearch/monthlyCost'])
        const dailyCost = computed(() => store.getters['$_dynamicSearch/dailyCost'])
        const resourceId = computed(() => store.getters['$_dynamicSearch/resourceId'])
        const usageAccountId = computed(() => store.getters['$_dynamicSearch/usageAccountId'])
        const region = computed(() => store.getters['$_dynamicSearch/region'])
        const productCode = computed(() => store.getters['$_dynamicSearch/productCode'])
        const productCategory = computed(() => store.getters['$_dynamicSearch/productCategory'])
        const availableTags = computed(() => store.getters['$_dynamicSearch/availableTags'])
        const tag = computed(() => store.getters['$_dynamicSearch/tag'])
        const detail = computed(() => store.getters['$_dynamicSearch/detail'])
        const itemDescription = computed(() => store.getters['$_dynamicSearch/itemDescription'])
        const fetchData = (params) => {
            reload.value = false
            fetchDynamicSearch(params).then(() => {
                reload.value = true
            })
        }
        const fetchDynamicSearch = (params) => store.dispatch('$_dynamicSearch/fetchDynamicSearch', params)
        const fetchDynamicSearchItemDescription = (params) => store.dispatch('$_dynamicSearch/fetchDynamicSearchItemDescription', params)
        const filterProject = ({ project }) => {
            if (project && project.cost) {
                delete project.cost
            }
            store.commit('FETCH_SELECTED_PROJECT', project)
        }
        const filterIndexes = (value) => {
            const params = {
                ...qtypeParam.value
            }
            if (value.length) {
                params.indexes = value
            }
            if (Object.keys(filter.value).length) {
                params.filter = filter.value
            }
            indexes.value = value
            fetchData(params)
        }
        const filterItems = ({ field, value }) => {
            // 값이 없거나, 배열이면서 길이가 0이거나, 태그 객체이면서 key도 없는 경우
            const isEmpty = !value ||
                (Array.isArray(value) && value.length === 0) ||
                (typeof value === 'object' && !Array.isArray(value) && !value.key)
            if (isEmpty) {
                delete filter.value[field]
            } else {
                filter.value[field] = value
            }
            if (!indexes.value.length && summary.value?.indexes) {
                indexes.value = summary.value.indexes
            }
            const params = {
                ...qtypeParam.value,
                indexes: indexes.value,
                filter: filter.value
            }
            fetchData(params)
        }
        const filterDescription = (items) => {
            const params = {
                ...qtypeParam.value,
                indexes: indexes.value,
                filter: {
                    usageDate: {
                        start: summary.value.start,
                        end: summary.value.end
                    },
                    ...filter.value,
                    ...items
                }
            }
            fetchDynamicSearchItemDescription(params)
        }
        const initFullData = () => {
            indexes.value = []
            // indexes.value = monthlyCost.value.map(item => item.key).slice()
            fullMonths.value = monthlyCost.value.slice()
            fullProductCode.value = productCode.value.slice()
            fullProductCategory.value = productCategory.value.slice()
            fullRegion.value = region.value.slice()
        }

        const handleScroll = () => {
            top.value = Math.min(-50 + (document.documentElement.scrollTop - 300) / 2, 60)
        }
        onUnmounted(() => {
            window.removeEventListener('scroll', handleScroll)
        })
        const lastQtypeParam = ref(null)
        watch(changeProject, (value, oldValue) => {
            const currentParam = JSON.stringify(qtypeParam.value)
            // 실제로 파라미터가 변경되었을 때만 API 호출
            if (lastQtypeParam.value === currentParam) {
                return
            }
            lastQtypeParam.value = currentParam
            reload.value = false
            const params = {
                ...qtypeParam.value
            }
            fetchDynamicSearch(params).then(() => {
                initFullData()
                reload.value = true
                filter.value = {}
            })
        }, {
            deep: true,
            immediate: true
        })
        return {
            theme,
            themeColors,
            filter,
            scrollTop,
            top,
            right,
            indexes,
            fullMonths,
            fullProductCode,
            fullProductCategory,
            fullRegion,
            selectedProject,
            summary,
            monthlyCost,
            dailyCost,
            availableTags,
            resourceId,
            usageAccountId,
            region,
            productCode,
            productCategory,
            tag,
            detail,
            itemDescription,
            filterProject,
            filterIndexes,
            filterItems,
            filterDescription,
            reload
        }
    }
}
</script>

<style lang="scss">
.dynamic-summary {
    position: fixed;
    left: 10px;
    right: 10px;
    opacity:0.9;
    // width:100%;
}
.lds-dual-ring {
    display: inline-block;
    width: 80px;
    height: 80px;
}
.lds-dual-ring:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
}
</style>
